/*
 * @Author: 曹捷
 * @Date: 2021-10-27 17:08:00
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-27 17:36:55
 * @Description: 通过reactive  监听 微前端路由跳转
 */
import { reactive } from 'vue'

let _data = reactive({
  url: ''
})

export const historyData = _data
/**
 * 微前端  路由跳转
 * @param {*} url 
 */
export const pushState = function (url) {
  _data.url = url
  history.pushState(null, url, url)
}